import { render } from "./AmongThem.vue?vue&type=template&id=289ffd58"
import script from "./AmongThem.vue?vue&type=script&lang=js"
export * from "./AmongThem.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__